module.exports = __webpack_public_path__ + "static/img/5.c79505f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/5.png
// module id = kdLr
// module chunks = 0